var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeather({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.107 9.933a.562.562 0 01.563-.563h4.564a.19.19 0 00.155-.08c2.293-3.186 3.305-6.693 1.557-8.444a.375.375 0 00-.566.046L12.864 4.41a.188.188 0 01-.32-.133V.745A.374.374 0 0012 .41 22.563 22.563 0 006.6 4.5a17.438 17.438 0 00-4.026 5.995c-.606 1.629-.682 3.007-.255 3.935l-1.93 1.924a.75.75 0 000 1.06.761.761 0 001.061 0l1.917-1.916c.57.262 1.192.39 1.819.375a10.691 10.691 0 006.14-2.413.19.19 0 00-.116-.34H7.295a.562.562 0 010-1.124h5.67c.05 0 .097-.02.133-.055a20.27 20.27 0 001.082-1.133.191.191 0 00.028-.202.19.19 0 00-.172-.11H10.67a.562.562 0 01-.563-.563z",
    fill: "#ECFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeather);
export default __webpack_public_path__ + "static/media/feather.c14f38fbac5a4283d1fea252b613587a.svg";
export { ForwardRef as ReactComponent };